import { Link } from 'react-router-dom';
import {
  ChevronRight,
  FileText, Cookie,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand-section">
              <Link to="/" className="footer-brand">
                <img src="/icon.png" alt="Cornetto Pro" className="footer-icon" />
                <span className="footer-tagline">
                  <span className="tagline-verify">Verify</span>
                  <span className="tagline-sep"> · </span>
                  <span className="tagline-certify">Certify</span>
                  <span className="tagline-sep"> · </span>
                  <span className="tagline-deliver">Deliver</span>
                </span>
              </Link>
              <p className="footer-description">
                {t('footer.description')}
              </p>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">{t('footer.columns.product')}</h4>
              <ul className="footer-column-links">
                <li><Link to="/products"><ChevronRight size={14} /> {t('footer.links.features')}</Link></li>
                <li><Link to="/certificates"><ChevronRight size={14} /> {t('footer.links.smartContracts')}</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">{t('footer.columns.legal')}</h4>
              <ul className="footer-column-links">
                <li><Link to="/privacy-policy"><FileText size={14} /> {t('footer.links.privacyPolicy')}</Link></li>
                <li><Link to="/terms-conditions"><FileText size={14} /> {t('footer.links.terms')}</Link></li>
                <li><Link to="/cookies-policy"><Cookie size={14} /> {t('footer.links.cookies')}</Link></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4 className="footer-column-title">{t('footer.columns.support')}</h4>
              <ul className="footer-column-links">
                <li><Link to="/support" state={{ subject: 'support', message: 'Hi, I need help with ' }}><ChevronRight size={14} /> {t('footer.links.support')}</Link></li>
                <li><Link to="/contact"><ChevronRight size={14} /> {t('footer.links.contactUs')}</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2026. {t('footer.rights')}</p>
          </div>
        </div>
      </footer>

    </>
  );
}
